import {bootstrapApplication} from '@angular/platform-browser'
import {defineCustomElements} from '@ionic/pwa-elements/loader'
import {passiveSupport} from 'passive-events-support/src/utils'
import {AppComponent} from './app/app.component'
import {appConfig} from './app/app.config'

passiveSupport({
  events: ['wheel', 'mousewheel', 'touchstart'],
})

// eslint-disable-next-line uve-solutions-street/enforce-logging-service
bootstrapApplication(AppComponent, appConfig).catch(err => console.log(err))

defineCustomElements(window)
